import { useState } from "react";

// Global state to track which specific events are being processed
let globalEventProcessingState = new Set<number>();

export const updateEventProcessingState = (matchEventId: number, isProcessing: boolean) => {
  if (isProcessing) {
    globalEventProcessingState.add(matchEventId);
  } else {
    globalEventProcessingState.delete(matchEventId);
  }
};

const isEventProcessing = (matchEventId: number): boolean => {
  return globalEventProcessingState.has(matchEventId);
};

// Hook for components that need to react to processing state changes
export const useEventProcessingState = () => {
  const [, forceUpdate] = useState({});

  const setEventProcessingState = (matchEventId: number, isProcessing: boolean) => {
    updateEventProcessingState(matchEventId, isProcessing);
    forceUpdate({}); // Force re-render of components using this hook
  };

  return {
    isEventProcessing,
    setEventProcessingState,
  };
};
